import { Component, OnInit ,Input} from '@angular/core';
import { ReportMetadata, ReportSchedule, ReportState, ReportYear, ReportCategory,Report,ReportStates} from '../../../models/report.model';
import {ReportService} from '../../../services/report.service';
import {LookupService} from '../../../services/lookups/lookup.service';
import { NotifierService } from 'angular-notifier';
import { ConfirmationService, SelectItem } from 'primeng/api';

@Component({
  selector: 'app-rptstatusmgmt',
  templateUrl: './rptstatusmgmt.component.html',
  styleUrls: ['./rptstatusmgmt.component.css']
})
export class RptstatusmgmtComponent implements OnInit {

ReportYears: ReportYear[];
@Input()
  ReportYear: ReportYear;
  displayStatusDlg:boolean;
  reportData:Report[];
  reportNames: SelectItem[];
  countries: SelectItem[];
  fasPosts: SelectItem[];
  reportNumbers: SelectItem[];
  distributionTypes: SelectItem[];
  reportStates: SelectItem[];
  reportTypes:SelectItem[];
  lstReportStates:SelectItem[];
  selectedState:SelectItem;
  reportId:any;
  constructor(private reportService:ReportService, private lookupService:LookupService,private notifier:NotifierService) { }

  ngOnInit() {

    this.getReportYears();
     this.loadReportsTable(this.ReportYear.year);
    
     
  }
   onYearSelected(value) {
       

      this.loadReportsTable(value.year);
      
    }

   loadReportsTable(year:any)
   {
      this.reportService.getAllReportsBasedOnYear$(year).subscribe((data:Report[])=>{
        //console.log(data);
        
        this.reportData =data;
        this.LoadTableFilters(data);    

    });
   }

    getReportYears()
    {
       this.ReportYear = new ReportYear();
      this.ReportYear.year = new Date().getFullYear();

      var Years = new Array<ReportYear>();
      Years = [
        { id: 1, year: this.ReportYear.year },
        { id: 2, year: this.ReportYear.year - 1 },
        { id: 3, year: this.ReportYear.year - 2 }
      ];
      this.ReportYears = Years;
    }


     LoadTableFilters(reportData: Report[]) {
    this.reportNumbers = this.GetUniqueValues(reportData.map(r => r.reportNumber));
    this.reportNames = this.GetUniqueValues(reportData.map(r => r.reportName));
    this.countries = this.GetUniqueValues(reportData.map(r => r.country));
    this.fasPosts = this.GetUniqueValues(reportData.map(r => r.fasPost));
    this.distributionTypes = this.GetUniqueValues(reportData.map(r => r.distribution));
    this.reportStates = this.GetUniqueValues(reportData.map(r => r.reportState));
    this.reportTypes = this.GetUniqueValues(reportData.map(r => r.reportType));
  }
     GetUniqueValues(vals: any[]): SelectItem[] {
    var returnArry = new Array<SelectItem>();
    for (let cnt = 0; cnt < vals.length; cnt++) {
      if (returnArry.filter(r => r.label == vals[cnt]).length == 0)
        returnArry.push({ label: vals[cnt], value: vals[cnt] });
    }
    //console.log(returnArry.length);

    returnArry.sort(
      (a, b): number => {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      }
    );
    return returnArry;
  }
  loadReportStates(reportStateId:number)
  {
      this.lstReportStates = new Array<SelectItem>();
      this.lookupService.getReportStates$().subscribe((data:ReportState[])=>{
       data=data.filter(x=>x.id !==ReportStates.NotStarted && x.id !== ReportStates.Hold && x.id!==ReportStates.Validated);

       data.forEach(element => {
         if(element.id !==reportStateId)
               this.lstReportStates.push({label:element.stateName,value:element.id});
       });
         
      });
  }

  onClickChangeStatus(report)
  {
    
     this.displayStatusDlg = true;
    this.loadReportStates(report.reportStateId);
    this.reportId = report.id;
  }
  onReportStatusChange()
  { 
    //console.log(this.reportId +"," +this.selectedState);
    this.reportService.updateReportState$(this.reportId, this.selectedState).subscribe((resp)=>{
      if(resp.ok)
      {
        this.notifier.notify("success","Report State has been changed successfully");
        this.reportData=this.reportData.filter(x=>x.id !== this.reportId);
        // this.reportData.forEach(element => {
        //   if(element.id === this.reportId)
        //   {
        //      this.lstReportStates.filter(item =>{
        //        console.log(item.label);
        //        if(item.value === this.selectedState)
        //            element.reportState= item.label;
                   
        //      }) 
        //   }
          
        // });
        //this.loadReportStates(parseInt(this.selectedState.toString()));
      }
      else
      {
       this.notifier.notify("error","Failed to change the Report state"); 
      }


    });
    this.displayStatusDlg =false;
  }
  onClose()
  {
    
    this.displayStatusDlg = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/report-management/rptstatusmgmt/rptstatusmgmt.component.ts